import type { NavImpactMegaMenuLinks } from '../../types';

export const SUPPORT_LINK = 'https://support.academia.edu';

export type MegaMenuItem = {
  label: string;
  href: string;
  locked: boolean;
};

export type MegaMenuColumn = {
  heading: string;
  items: MegaMenuItem[];
};

export type MegaMenuUtilityIcon = 'premium-lock' | 'tune' | 'help' | 'article';

export type MegaMenuUtilityItem = {
  label: string;
  href: string;
  icon: MegaMenuUtilityIcon;
};

function coScientistColumn(links: NavImpactMegaMenuLinks): MegaMenuColumn[] {
  const coScientist = links.coScientist;
  if (coScientist == null) {
    return [];
  }
  return [
    {
      heading: 'Co-scientist',
      items: [
        {
          label: 'Suggested tasks',
          href: coScientist.suggestedTasks,
          locked: false,
        },
        { label: 'Your tools', href: coScientist.yourTools, locked: false },
        {
          label: 'Recent chats',
          href: coScientist.recentChats,
          locked: false,
        },
      ],
    },
  ];
}

function fundingColumn(links: NavImpactMegaMenuLinks): MegaMenuColumn[] {
  if (links.grants == null) {
    return [];
  }
  return [
    {
      heading: 'Funding',
      items: [{ label: 'Find grants', href: links.grants, locked: false }],
    },
  ];
}

export function megaMenuColumns(
  links: NavImpactMegaMenuLinks,
): MegaMenuColumn[] {
  return [
    ...coScientistColumn(links),
    {
      heading: 'Find research',
      items: [
        {
          label: 'Reference finder',
          href: links.referenceFinder,
          locked: false,
        },
        {
          label: 'Research topics',
          href: links.researchTopics,
          locked: false,
        },
        {
          label: 'Advanced search',
          href: links.advancedSearch,
          locked: true,
        },
        {
          label: 'Search alerts',
          href: links.searchAlerts,
          locked: true,
        },
        {
          label: 'PDF Packs',
          href: links.pdfPacks,
          locked: true,
        },
      ],
    },
    {
      heading: 'Track my impact',
      items: [
        {
          label: 'Paper views',
          href: links.paperViews,
          locked: false,
        },
        {
          label: 'Paper downloads',
          href: links.paperDownloads,
          locked: false,
        },
        {
          label: 'Citations',
          href: links.citations,
          locked: true,
        },
        {
          label: 'Profile visitors',
          href: links.profileVisitors,
          locked: true,
        },
      ],
    },
    {
      heading: 'Publish',
      items: [
        {
          label: 'Academia.edu Journals',
          href: links.journals,
          locked: false,
        },
        {
          label: 'All journal articles',
          href: links.journalArticles,
          locked: false,
        },
        {
          label: 'My submissions',
          href: links.submissions,
          locked: false,
        },
        {
          label: 'Reviewer Hub',
          href: links.reviewerHub,
          locked: false,
        },
        {
          label: 'Editor Hub',
          href: links.editorHub,
          locked: false,
        },
      ],
    },
    ...fundingColumn(links),
    {
      heading: 'Network',
      items: [
        {
          label: 'Share research',
          href: links.shareResearch,
          locked: false,
        },
        { label: 'Followers', href: links.followers, locked: false },
        { label: 'Following', href: links.following, locked: false },
        {
          label: 'Find colleagues',
          href: links.findColleagues,
          locked: false,
        },
        {
          label: 'Start a discussion',
          href: links.startDiscussion,
          locked: false,
        },
      ],
    },
  ];
}

export function megaMenuUtilityItems(
  isPremium: boolean,
  links: NavImpactMegaMenuLinks,
): MegaMenuUtilityItem[] {
  const upgradeItem: MegaMenuUtilityItem = {
    label: 'Try Academia Premium',
    href: links.tryPremium,
    icon: 'premium-lock',
  };

  return [
    ...(isPremium ? [] : [upgradeItem]),
    {
      label: 'Improve recommendations',
      href: links.recommendations,
      icon: 'tune',
    },
    { label: 'Help center', href: SUPPORT_LINK, icon: 'help' },
    {
      label: 'Community standards',
      href: links.communityStandards,
      icon: 'article',
    },
  ];
}
